<div class="invest-container">
  <app-product-intro-banner
    [eyebrow]="'invest.introBanner.eyebrow' | translate"
    [headline]="'invest.introBanner.headline' | translate"
    [description]="'invest.introBanner.description' | translate"
    [primaryCtaLabel]="'invest.introBanner.primaryCtaLabel' | translate"
    [secondaryCtaLabel]="'invest.introBanner.secondaryCtaLabel' | translate"
    [mediaImageSrc]="introBannerAssets.mediaImageSrc"
    [mediaImageAlt]="'invest.introBanner.mediaImageAlt' | translate"
    [videoSrc]="introBannerAssets.videoSrc"
    [videoTitle]="'invest.introBanner.videoTitle' | translate"
    [primaryCtaUrl]="investRegisterUrl"
  ></app-product-intro-banner>

  <app-product-how-it-works
    [headline]="productHowItWorksContent.headline"
    [tabs]="productHowItWorksContent.tabs"
  ></app-product-how-it-works>

  <app-product-program-benefits
    [headline]="productProgramBenefitsContent.headline"
    [description]="productProgramBenefitsContent.description"
    [stats]="productProgramBenefitsContent.stats"
    [cards]="productProgramBenefitsContent.cards"
  ></app-product-program-benefits>

  <!-- <app-product-testimonials
    [testimonials]="productTestimonialsContent.testimonials"
  ></app-product-testimonials> -->
</div>
